import React from 'react';
import { getOrgTermsContent } from '../../../../../content/utils.js';
import PageHeader from '../../../PageHeader.js';
import BreadCrumbs from '../../../../BreadCrumbs.jsx';
import ProjectBreadcrumbIcon from '../../../../icons/ProjectBreadcrumbIcon.jsx';
import {
  ProjectLink,
  ProjectsLink,
  ProjectStakeholdersLink,
} from '../../../../links/index.jsx';

const StakeholdersSettingsHeader = ({ project }) => {
  return (
    <PageHeader flex>
      <BreadCrumbs icon={<ProjectBreadcrumbIcon />}>
        <ProjectsLink>{getOrgTermsContent('projects')}</ProjectsLink>
        <ProjectLink projectId={project.id}>{project.name}</ProjectLink>
        <ProjectStakeholdersLink projectId={project.id}>
          Stakeholder Analysis
        </ProjectStakeholdersLink>
        <span>Customize Stakeholder Analysis</span>
      </BreadCrumbs>
    </PageHeader>
  );
};
export default StakeholdersSettingsHeader;
